export default ({ color = '#727B8C' }) => (
  <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="6" cy="6" r="5.5" stroke={color} /> <path d="M6 9.75V5.25" stroke={color} strokeWidth="1.5" />
    <path d="M6 4.125V3" stroke={color} strokeWidth="1.5" />
  </svg>
)
